const data = {
  name: "Milos Popovic",
  url: "https://milospopovic.net/",
  imageUrl: "milos.png",
  description:
    "Milos Popovic is a Data Analyst at Booking.com in Amsterdam. His research explores how countries intervene in civil wars abroad. He uses R to create maps that make sense of big data. According to NodeXL, he is a Top 10 dataviz and R contributor on Twitter",
  tags: ["frontend", "personal", "React", "Gatsby", "JavaScript", "GraphQL"],
}

export default data
